<template>
	<div class="user-dashboard">
		<UserMenu/>
		<div class="main-panel">
			<TopNav/>
			<div class="content">
				<div class="row">
					<div class="col-md-12">
						<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
						<div class="card" v-if="asyncDone === false">
							<div class="loader"></div>
						</div>
						<div class="card">
							<div class="card-header">
								<h4 class="card-title">Collaborator</h4>
							</div>
							<div class="card-body">
								<ul class="nav nav-tabs" id="myTab" role="tablist">
									<li class="nav-item">
										<a class="nav-link active show" id="up-tab"
											data-toggle="tab" href="#up" role="tab" aria-controls="up">
											Accounts I have Access to
										</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" id="down-tab" data-toggle="tab" href="#down" role="tab"
											aria-controls="down">
											Access to my account
										</a>
									</li>
								</ul>
								<div class="card-body pb-0">
									<div class="tab-content customer-table">
										<div id="up" class="tab-pane active show">
											<CollaboratorList/>
										</div>
										<div id="down" class="tab-pane fade">
											<SupervisorList />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: "Collaborator",
        components: {
            Alert: () =>
                import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
            UserMenu: () =>
                import(/* webpackChunkName: "userMenu" */ "../../../components/User/SideMenu.vue"),
            TopNav: () =>
                import(/* webpackChunkName: "topNav" */ "../../../components/TopNav.vue"),
            CollaboratorList: () =>
                import(/* webpackChunkName: "CollaboratorList" */ "../../../components/User/Collaborator/CollaboratorList.vue"),
            SupervisorList: () =>
                import(/* webpackChunkName: "CollaboratorList" */ "../../../components/User/Collaborator/SupervisorList.vue"),
        },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            alertType() {
                return this.$store.getters["alert/type"];
            },
            alertMessage() {
                return this.$store.getters["alert/message"];
            },
            alertShow() {
                return this.$store.getters["alert/show"];
            }
        },
    }
</script>
<style scoped>
	.nav-tabs .nav-item .nav-link.active:before,
	.nav-tabs .nav-item .nav-link.active:hover:before,
	.nav-tabs .nav-item .nav-link.active:focus:before {
		border: 0;
	}

	.nav-tabs {
		border-bottom: 1px solid #dee2e6;
	}

	.nav-tabs .nav-link {
		border: 1px solid transparent !important;
		border-top-left-radius: .25rem;
		border-top-right-radius: .25rem;
	}

	.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
		color: #495057;
		background-color: #fff;
		border-color: #dee2e6 #dee2e6 #fff !important;
	}

	.nav-tabs .nav-item .nav-link.active {
		color: #5B7CFB;
	}
</style>